export default {
  data() {
    return {
      // User Basic
      formBasicUser: {
        act: true, // is the object able to be used
        atn: false,
        admin: false, // admin of app - high previlages
        hist: false, // history document (archived)
        lock: false, // if true can not change data
        link: false, // issue is linked with other issue
        list: false, // item in the list recently accessed or modified
        save: true, // save is enabled
        read: false, // read is enabled
        pass: "",
        key: "", // pass key for important safety transetcins
        gate: "", // gate key
        email: "", // user email
        did: "", // documet id
        uid: "", // unique user id
        id: "", // user defined
        idg: "", // generated id
        idi: 0, // useful for indexing
        ids: "", // id special
        rdp: "", // rev. of data privacy
        rlic: "Free", // rev. of licence (app privialages)
        rtc: "", // rev. of terms and conditions
        tag: "U1",
        type: "", // type of document
        title: "", // title is user name
        ver: "", // version of data model
        verify: "" // verify level L1 - std, L2 - standard, L3 - skill
      },
      // Access Permissions
      formBasicAccess: {
        act: false, // is the object able to be used
        atn: false,
        save: true,
        lock: false,
        link: false, // issue is linked with other issue
        read: false,
        list: false, // item in the list recently accessed or modified
        tag: "G1", // tag for transaction / or whatever
        tagd: "U1", // tag destination, where this access stored (path)
        tags: "C1", // sourcs tag for which the doument is sources from
        did: "", // id for the database
        id: "", // unique to local asset/facility/database
        idi: 0, // index used for list
        idg: "", // system generated id
        hash: "", // tags and others to assiste with hash
        title: "", // legal company name,
        type: "", // type of document
        ver: ""
      },
      // Document
      formBasicGeneral: {
        act: false, // active true / false
        atn: false,
        copy: false, // what is copied from other document
        save: true, // save is enabled
        lock: false, // document is locked and active
        link: false, // document is lincked with other issue
        read: false, // is document read
        list: false, // item in the list recently accessed or modified
        tag: "", // tag for transaction / or notification
        did: "", // id for the database
        id: "", // unique to local asset/facility/database id or doc id
        idi: 0, // index used for list (essetial)
        idp: "", // id physical assets / facilities
        idg: "", // system generated id (Auto generayed)
        idm: "", // master doucmnt if applicable / org. doc of duplicate
        ids: "", // special id
        hash: "", // tags and others to assiste with hash
        title: "", // user defined title // of document,
        type: "", // type of document
        ver: "", // version of da model
        verify: "" // verification system
      },
      // Items or Log
      formBasicSimple: {
        act: false, // active true / false
        tag: "", // tag for transaction / or notification
        did: "", // id for the database
        id: "", // business id
        idg: "", // generated id
        list: false, // access list
        idi: 0, // index used for list (essetial),
        title: "", // document title
        ver: "" // used for archives
      }
    };
  }
};
